import React from 'react';

import { PortalConfig } from 'src/context';
import {
  isI18nResourceLoaded,
  loadI18nResources,
  reloadI18nResources,
} from 'src/i18n/i18next.config';

export const useI18nResources = ({
  customLabels,
}: {
  customLabels: PortalConfig['features']['customLabels'] | null;
}): void => {
  React.useEffect(() => {
    if (!isI18nResourceLoaded()) {
      loadI18nResources({ customLabels });
    } else {
      reloadI18nResources({ customLabels });
    }
  }, [customLabels]);
};
